module.exports = __webpack_public_path__ + "static/advanced features-audio cleanup-b5471303430d47d49b28962d1bbcf52a.png";